/**
 * Constantes partagées pour le lecteur d'overlays (OverlayPlayer).
 * Centralise les valeurs magiques pour la maintenance et la testabilité.
 */

/** Noms des mois en français pour l'affichage des anniversaires */
export const MONTH_NAMES = [
  'Janvier',
  'Février',
  'Mars',
  'Avril',
  'Mai',
  'Juin',
  'Juillet',
  'Août',
  'Septembre',
  'Octobre',
  'Novembre',
  'Décembre',
];

/** Nombre de jours à l'avance pour afficher les anniversaires "proches" */
export const UPCOMING_BIRTHDAY_DAYS = 30;

/** Durée de l'animation de disparition des anniversaires (ms) */
export const BIRTHDAY_EXIT_ANIMATION_MS = 350;

/** Durée par défaut d'affichage de l'overlay anniversaires (ms) */
export const DEFAULT_BIRTHDAY_DURATION_MS = 10000;

/** Durée par défaut d'affichage d'une image (ms) */
export const DEFAULT_IMAGE_DURATION_MS = 5000;

/** Taille max du Set des overlays traités avant nettoyage (évite fuite mémoire) */
export const PROCESSED_OVERLAYS_MAX_SIZE = 100;

/** Nombre d'IDs à conserver après nettoyage du Set des overlays traités */
export const PROCESSED_OVERLAYS_TRIM_TO = 50;

/** Délai (ms) avant d'appeler playNextOverlay après fin overlay anniversaires */
export const DELAY_PLAY_NEXT_AFTER_BIRTHDAY_MS = 200;

/** Délai (ms) avant d'appeler playNextOverlay après fin vidéo */
export const DELAY_PLAY_NEXT_AFTER_VIDEO_MS = 300;

/** Délai (ms) avant d'appeler playNextOverlay après fin image */
export const DELAY_PLAY_NEXT_AFTER_IMAGE_MS = 500;

/** Durée de l'animation d'entrée du podium (ms) */
export const LEADERBOARD_ENTER_ANIMATION_MS = 600;

/** Durée de l'animation de sortie du podium (ms) */
export const LEADERBOARD_EXIT_ANIMATION_MS = 600;

/** Durée d'affichage du podium : min (s) */
export const LEADERBOARD_DISPLAY_DURATION_MIN_SEC = 1;

/** Durée d'affichage du podium : max (s) */
export const LEADERBOARD_DISPLAY_DURATION_MAX_SEC = 120;

/** Durée d'affichage du podium par défaut (s) */
export const LEADERBOARD_DISPLAY_DURATION_DEFAULT_SEC = 10;

/** Nom de récompense leaderboard par défaut */
export const LEADERBOARD_REWARD_NAME_DEFAULT = 'First';

/** Nombre d'entrées affichées sur le podium (top N) */
export const LEADERBOARD_TOP_COUNT = 3;
